// extracted by mini-css-extract-plugin
export default {"tooltip":"gW-z","arrow":"hW-z"};